import  * as http from '../utils/request';
import {jsonToFormData} from "@/utils";

//GET /role/getMenuByListID

export async function getMenuByListID () {
  const  role= sessionStorage.getItem("roleIds")
  // console.log(role)
 const response=  await http.get("/role/getMenuByListID?str="+role);
 if(response && response.data){
   return response.data
  //  let ids=[];
  //  response.data.forEach((item,i)=>{
  //    if(item.isdisplay==0){
  //      ids.push(item.id);
  //    }
  //  });
  //  return ids;
 }
 return [];
}

//分页查询角色列表
export function roleList(page,params) {
  return http.postJSON("/role/findPage?" + jsonToFormData(page), params)
}

// 分页查询角色列表
// export  const roleList =({name,userName,menuArray,page,size})=>{
//   return http.get('/role/findPage',{name,userName,menuArray,page,size})
// }
 
//新增角色
export function insert(name,description){
  return http.postForm("/role/insert",name,description);
}

//编辑角色
export function update(name,description,id){
  return http.postForm("/role/update",name,description,id);
}

// 角色管理操作日志
export  const roleLog =({id,page,size})=>{
  return http.get('/log/getLogRole',{id,page,size})
}

export function findRoleMenu(roleid) {
  return http.get("/role/findRoleMenu",{roleid})
}
//新增权限
export function insertMenu(page,params) {
  return http.postJSON("/role/insertRelation?"+jsonToFormData(page),params)
}
//所有菜单权限
export function loadAll() {
  return http.get("/menu/loadAll");
}


export function loadLogo(){
  return http.postForm("/operatorController/selectByOperatorPic",{})
}




// WEBPACK FOOTER //
// ./src/services/role.js